import React from 'react'
import {Formik} from 'formik'
import * as Yup from 'yup'
import {useIntl} from 'react-intl'
import Auth from 'lib/auth'
import {useAuthentication} from 'components/providers/AuthenticationProvider'
import {Box, Typography, Toolbar, Container} from '@material-ui/core'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import LoaderButton from 'components/atoms/LoaderButton'

const validationSchema = Yup.object().shape({
  name: Yup.string().required('formValidations.required'),
  country: Yup.string().required('formValidations.required'),
})

export default function SetupPage({api}) {
  const {setTenant} = useAuthentication()
  const intl = useIntl()

  return (
    <Box component="div" mt={5} pt={5}>
      <Container maxWidth="sm">
        <Typography variant="h5" component="h1">
          {intl.formatMessage({id: 'setup.title'})}
        </Typography>
        <Formik
          initialValues={{name: '', country: ''}}
          validationSchema={validationSchema}
          onSubmit={async ({name, country}) => {
            const tenant = await api.createTenant({name, country})
            const user = await Auth.currentAuthenticatedUser()
            Auth.switchTenant(user, tenant)
            setTenant(tenant)
          }}
        >
          {({handleSubmit, handleChange, handleBlur, errors, touched, values, isSubmitting}) => {
            return (
              <form noValidate onSubmit={handleSubmit}>
                <TextField
                  id="name"
                  name="name"
                  label={intl.formatMessage({id: 'setup.tenantName'})}
                  fullWidth required autoFocus value={values['name']}
                  margin="normal" onChange={handleChange} onBlur={handleBlur}
                  error={touched['name'] && Boolean(errors['name'])}
                  helperText={
                    touched['name'] &&
                    errors['name'] &&
                    intl.formatMessage({id: errors['name']})
                  }
                />
                <TextField
                  id="country"
                  name="country"
                  select fullWidth required
                  label={intl.formatMessage({id: 'setup.country'})}
                  value={values['country']}
                  margin="normal" onChange={handleChange} onBlur={handleBlur}
                  error={touched['country'] && Boolean(errors['country'])}
                  helperText={
                    touched['country'] &&
                    errors['country'] &&
                    intl.formatMessage({id: errors['country']})
                  }
                >
                  <MenuItem value="">
                    {intl.formatMessage({id: 'selectPrompt'})}
                  </MenuItem>
                  <MenuItem value="IN">India</MenuItem>
                  <MenuItem value="GB">United Kingdom</MenuItem>
                </TextField>
                <Toolbar disableGutters>
                  <LoaderButton
                    type="submit"
                    variant="outlined"
                    size="large"
                    color="primary"
                    isLoading={isSubmitting}
                    loadingText={intl.formatMessage({id: 'setup.submitting'})}
                  >
                    {intl.formatMessage({id: 'setup.button'})}
                  </LoaderButton>
                </Toolbar>
              </form>
            )
          }}
        </Formik>
      </Container>
    </Box>
  )
}
